import React from "react";
import {
  Button,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Typography,
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import "./OrderDetails.css";
import { formatTimeTo12Hour, formatDateToReadable } from "../../Dialog/helper";
import { useNavigate } from "react-router-dom";

const OrderDetailsChallenge = ({ orderDetails }) => {
  const navigate = useNavigate();
  const bookingTime = formatTimeTo12Hour(orderDetails?.time_created);
  const bookingDate = formatDateToReadable(orderDetails?.date_created);
  const currencySymbol =
    orderDetails?.challenge_purchase?.currency === "INR" ? "₹" : "$";

  const isPurchased =
    orderDetails?.payment_status_str?.toLowerCase() === "paid";

  const handleFeedbackLinkClick = () => {
    navigate(
      `/challenges/${orderDetails?.challenge_purchase?.challenge?.slug}/feedback`
    );
  };

  return (
    <div className="workshop-purchase-details-container">
      {/* Left Section */}
      <div className="workshop-purchase-details-left">
        <div className="workshop-purchase-details-image-container">
          <img
            src={orderDetails?.challenge_purchase?.challenge?.hero_image}
            alt={orderDetails?.challenge_purchase?.challenge?.slug}
            className="workshop-purchase-details-image"
          />
          <div className="workshop-purchase-details-title">
            {orderDetails?.challenge_purchase?.challenge?.title}
          </div>
        </div>
        <p className="workshop-description">
          {orderDetails?.challenge_purchase?.challenge?.description}
        </p>
        <Button
          variant="contained"
          className="feedback-button"
          onClick={handleFeedbackLinkClick}
        >
          Write feedback
        </Button>
      </div>

      {/* Right Section */}
      <div className="workshop-purchase-details-right">
        {/* Challenge Details */}
        <Accordion defaultExpanded>
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            sx={{ backgroundColor: "#e3e3e3" }}
          >
            <Typography>Challenge Details</Typography>
          </AccordionSummary>
          <AccordionDetails>
            <div className="booking-info">
              <div>
                <span>Challenge Title:</span>
                <span>
                  {orderDetails?.challenge_purchase?.challenge?.title}
                </span>
              </div>
              {/* <div>
                <span>Challenge Batch:</span>
                <span>
                  {orderDetails?.challenge_purchase?.challenge?.batch?.title}
                </span>
              </div>
              <div>
                <span>Challenge Duration:</span>
                <span>
                  {orderDetails?.challenge_purchase?.challenge?.duration} days
                </span>
              </div> */}
            </div>
          </AccordionDetails>
        </Accordion>

        <Accordion defaultExpanded>
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            sx={{ backgroundColor: "#e3e3e3" }}
          >
            <Typography>Booking Details</Typography>
          </AccordionSummary>
          <AccordionDetails>
            <div className="booking-info">
              <div>
                <span>Booking ID:</span>
                <span>{orderDetails?.order?.id}</span>
              </div>
              <div>
                <span>Booking Date:</span>
                <span>{bookingDate}</span>
              </div>
              <div>
                <span>Booking Time:</span>
                <span>{bookingTime}</span>
              </div>
              <div className="booking-main-info">
                <span className="grand-total-label">Booking Total:</span>
                <span className="grand-total-price">
                  {currencySymbol}
                  {orderDetails?.challenge_purchase?.total_pay}
                </span>
              </div>
            </div>
          </AccordionDetails>
        </Accordion>

        {/* Payment Details */}
        <Accordion defaultExpanded>
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            sx={{ backgroundColor: "#e3e3e3" }}
          >
            <Typography>Payment Details</Typography>
          </AccordionSummary>
          <AccordionDetails>
            <div className="payment-info">
              <div>
                <span>Payment Method:</span>
                <span>{orderDetails?.payment_method}</span>
              </div>
              <div>
                <span>Payment ID:</span>
                <span>{orderDetails?.transaction_id}</span>
              </div>
              <div className="booking-main-info">
                <span className="grand-total-label">Payment Status:</span>
                <span
                  className={`grand-payment-status ${orderDetails?.payment_status_str.toLowerCase()}`}
                >
                  {orderDetails?.payment_status_str}
                </span>
              </div>
            </div>
          </AccordionDetails>
        </Accordion>

        {/* Price Info */}
        <Accordion defaultExpanded>
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            sx={{ backgroundColor: "#e3e3e3" }}
          >
            <Typography>Price Details</Typography>
          </AccordionSummary>
          <AccordionDetails>
            <div className="price-info">
              <div>
                <span>Item Total (Tax incl.):</span>
                <span>
                  {currencySymbol}
                  {orderDetails?.challenge_purchase.mrp}
                </span>
              </div>
              <div>
                <span>Discount:</span>
                <span>
                  {currencySymbol}
                  {orderDetails?.challenge_purchase?.discount_amt}
                </span>
              </div>
              {orderDetails?.challenge_purchase?.coupon_discount_amt > 0 && (
                <div>
                  <span>Coupon discount amount:</span>
                  <span>
                    {currencySymbol}
                    {orderDetails?.challenge_purchase?.coupon_discount_amt}
                  </span>
                </div>
              )}
              {orderDetails?.challenge_purchase?.referral_discount_amt > 0 && (
                <div>
                  <span>Platform Fee:</span>
                  <span>
                    {currencySymbol}
                    {orderDetails?.challenge_purchase?.platform_amt}
                  </span>
                </div>
              )}
              <div className="booking-main-info">
                <span className="grand-total-label">Grand Total:</span>
                <span className="grand-total-price">
                  {currencySymbol}
                  {orderDetails?.challenge_purchase?.total_amt}
                </span>
              </div>
            </div>
          </AccordionDetails>
        </Accordion>
      </div>
    </div>
  );
};

export default OrderDetailsChallenge;
